import { useTheme } from '@emotion/react';
import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Grid,
  InputAdornment,
  TextField,
  useMediaQuery,
  IconButton,
} from '@mui/material';
import Dialog from '@mui/material/Dialog';
import Typography from '@mui/material/Typography';
import { getApiCall, postApiCall } from 'api/apiService';
import keyicon from 'assets/images/keyicon.png';
import Loading from 'assets/images/loading.png';
import LoginBottom from 'assets/images/login-bottom.png';
import Image from 'assets/images/login-top.png';
import mailicon from 'assets/images/mailicon.png';
import { LoaderContext } from 'component/Loader/LoaderContextProvider';
import {
  forgotPasswordLink,
  loginFormHeader,
  loginFormHeadersm,
  loginFormText,
  loginFormTextsm,
  loginLabelEmail,
  loginMailDiv,
  loginPassCont,
  remberTextField,
} from 'component/Login/Login.style';
import {
  BUYER_REVIEW,
  GETBUYER_SOLICITOR_BY_ID,
  LOGIN_URL,
} from 'constant/app.config';
import { useContext, useState } from 'react';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { toast } from 'react-toastify';
import { paddTop10, poppins400, poppins500 } from 'theme/common.style';
import { validateEmail } from 'utils/validation.util';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import ForgotPassword from 'modules/public/LoginPage/ForgotPassword';
import SendOTP from 'modules/public/LoginPage/SendOTP';
import ShowNewPassword from 'modules/public/LoginPage/ShowNewPassword';
import { activestatus } from 'api/rcpapiService';
const RetrexLogo = () => {
  return (
    <svg
      width="217"
      height="217"
      viewBox="0 0 217 217"
      fill="none"
      href="http://www.w3.org/2000/svg"
    >
      <rect width="217" height="217" fill="url(#pattern0_30624_49626)" />
      <defs>
        <pattern
          id="pattern0_30624_49626"
          patternContentUnits="objectBoundingBox"
          width="1"
          height="1"
        >
          <use href="#image0_30624_49626" transform="scale(0.00125)" />
        </pattern>
        <image
          id="image0_30624_49626"
          width="800"
          height="800"
          href="data:image/png;base64,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"
        />
      </defs>
    </svg>
  );
};
const Warning = () => {
  return (
    <svg
      width="38"
      height="36"
      viewBox="0 0 38 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        width="37.5797"
        height="36"
        rx="18"
        fill="#10D35E"
        fill-opacity="0.1"
      />
      <path
        d="M27.0817 21.4607L21.3085 11.456C20.7883 10.5551 19.8271 10 18.7866 10C17.7462 10 16.7851 10.5551 16.2648 11.456L10.3902 21.632C9.86994 22.5329 9.86994 23.6431 10.3902 24.544C10.9104 25.4449 11.8715 26 12.912 26H24.6614C24.6646 26 24.6677 26 24.6677 26C26.276 26 27.5797 24.6962 27.5797 23.088C27.5797 22.4853 27.3957 21.9239 27.0817 21.4607ZM20.0333 22.4345C20.0333 23.1229 19.5036 23.6495 18.7898 23.6495C18.0761 23.6495 17.5464 23.1229 17.5464 22.4345V22.406C17.5464 21.7208 18.0761 21.1911 18.7898 21.1911C19.5036 21.1911 20.0333 21.7177 20.0333 22.406V22.4345ZM20.0619 14.2443L19.4465 19.6178C19.4052 20.0048 19.1483 20.2458 18.7898 20.2458C18.4314 20.2458 18.1745 20.0016 18.1332 19.6178L17.5178 14.2411C17.4766 13.8255 17.7019 13.5115 18.0888 13.5115H19.4877C19.8747 13.5147 20.1031 13.8287 20.0619 14.2443Z"
        fill="#10D35E"
      />
    </svg>
  );
};

export function MarketInvitePopup(props) {
  const {
    onClose,
    open,
    address,
    dontallowtooffer,
    scrollPercentage,
    showActivateTradeForSharePage,
    tabData,
    setTabDAta,
  } = props;
  const theme = useTheme();
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));
  const matchesmd = useMediaQuery(theme.breakpoints.down(1000));
  const matcheslg = useMediaQuery(theme.breakpoints.down('lg'));
  const matches400 = useMediaQuery(theme.breakpoints.down(400));
  const matches500 = useMediaQuery(theme.breakpoints.down(500));
  const [lastSeenUser, setLastSeenUser] = useState('');
  const { setLoaderConfig } = useContext(LoaderContext);
  const [remember, setRemember] = useState(false);
  const [logLoader, setLogLoader] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handleTogglePassword = () => {
    setShowPassword((prev) => !prev);
  };

  const [shownewpassword, setShowNewPassword] = useState(false);
  const [showForgotPassword, setShowForgotPassword] = useState(false);
  const [showsendOTP, setShowsendOTP] = useState(false);
  const [otpResponseObj, setotpResponseObj] = useState({});

  const handleForgotPasswordClick = (e) => {
    e.preventDefault();
    setShowForgotPassword(true);
  };

  const handleShowNewPassword = () => {
    setShowNewPassword(!shownewpassword);
  };

  let scrollPercentageValue = scrollPercentage;

  const emailText = {
    fontFamily: 'poppins',
    fontSize: '12px',
    fontWeight: 700,
  };
  const emailForgot = {
    fontFamily: 'poppins',
    fontSize: '10px',
    fontWeight: 300,
    color: '#000000',
  };

  const [formValues, setFormValues] = useState({
    userEmail: {
      value: '',
      error: false,
      errorMessage: 'Please enter the email address',
    },
    userPassword: {
      value: '',
      error: false,
      errorMessage: 'Password required',
      showPassword: false,
    },
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    const updatedValue = name == 'userEmail' ? value.toLowerCase() : value;
    setFormValues({
      ...formValues,
      [name]: {
        ...formValues[name],
        value: updatedValue,
      },
    });
  };

  // from shared property login get "property id" for login

  const history = useHistory();
  const pathname = history.location.pathname;
  const lastId = pathname.substring(pathname.lastIndexOf('/') + 1);

  const callLoginApi = () => {
    setLogLoader(true);
    const params = {
      value: formValues.userEmail.value,
      password: formValues.userPassword.value,
    };
    try {
      postApiCall(LOGIN_URL, params)
        .then(async (res) => {
          if (res?.data?.status == '-1') {
            toast.error(res?.data?.message, {
              position: 'top-right',
              autoClose: 2000,
              hideProgressBar: false,
              closeOnClick: true,
              progress: 0,
              theme: 'light',
              style: {
                fontFamily: 'Poppins', // 👈 Inline Poppins font
              },
            });
            setLogLoader(false);
            return;
          } else {
            localStorage.removeItem('isexpired');
            activestatus(true, res?.data?.moxoToken); // Set user as active on login (RCP)
            if (remember == true) {
              toast.success('Email Saved !', {
                position: 'top-right',
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                progress: 0,
                theme: 'light',
                style: {
                  fontFamily: 'Poppins', // 👈 Inline Poppins font
                },
              });
              localStorage.setItem('rememberemail', formValues.userEmail.value);
              localStorage.setItem('remember', true);
            } else {
              localStorage.setItem('remember', false);
              setRemember(false);
            }
            await localStorage.setItem('isLoginLoading', 'true');
            let primaryUserTypeval = res?.data?.primaryUserType;
            await localStorage.setItem('isFirstLogin', res?.data?.isFirstLogin);
            await localStorage.setItem('isLogin', 'true');
            await localStorage.setItem('userDetail', JSON.stringify(res?.data));
            await localStorage.setItem(
              'primaryUser',
              JSON.stringify(res?.data?.primaryUserType)
            );
            localStorage.setItem(
              'useremail',
              JSON.stringify(res?.data?.userEmail)
            );

            await localStorage.setItem(
              'userType',
              JSON.stringify(res?.data?.userType[0])
            );

            await localStorage.setItem('lastSeenUser', res?.data?.lastSeenUser);
            let lastSeenUser = await localStorage.getItem('lastSeenUser');
            setLastSeenUser(lastSeenUser);
            await localStorage.setItem(
              'token',
              res?.data?.token?.original?.token
            );
            await localStorage.setItem(
              'accesstoken',
              res?.data?.token?.original?.token
            );
            localStorage.setItem(
              'moxoDetail',
              JSON.stringify(res?.data?.moxoToken)
            );
            localStorage.setItem(
              'moxoUserId',
              JSON.stringify(res?.data?.moxoUserId)
            );
            setLoaderConfig({ isVisible: true });
            //buyer solicitor getapi
            if (res?.data?.primaryUserType == 'Buyer') {
              getApiCall(GETBUYER_SOLICITOR_BY_ID).then((res) => {
                if (res?.data?.status == 1) {
                  localStorage.setItem('buyerSolicitor', 'Yes');
                  localStorage.setItem(
                    'buyerSolicitorDetails',
                    JSON.stringify(res?.data?.data)
                  );
                } else {
                  localStorage.setItem('buyerSolicitor', 'No');
                }
              });
            }
            if (primaryUserTypeval.includes('Solicitor')) {
              setLoaderConfig({ isVisible: false });
              history.push('/solicitor');
            } else if (primaryUserTypeval.includes('Buyer')) {
              getApiCall(BUYER_REVIEW).then((response) => {
                if (response?.data?.status == 1) {
                  if (response?.data?.propertyList?.length > 0) {
                    setLoaderConfig({ isVisible: false });
                    history.push('/Survey');
                  } else {
                    history.push(`/market/${lastId}`, {
                      scrollPercentageValue: scrollPercentageValue,
                      showActivateTradeForSharePageValue:
                        showActivateTradeForSharePage,
                      activeTabData: tabData,
                    });
                    window.location.reload();
                  }
                }
              });
            } else {
              history.push('/');
            }
          }
        })
        .catch((err) => setLogLoader(false));
    } catch (error) {
      setLogLoader(false);
      console.log(error);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!validateEmail(formValues.userEmail.value)) {
      let triggerSubmit = true;
      const formFields = Object.keys(formValues);
      let newFormValues = { ...formValues };
      for (let index = 0; index < formFields.length; index++) {
        const currentField = formFields[index];
        const currentValue = formValues[currentField].value;
        if (currentValue === '') {
          triggerSubmit = false;
          newFormValues = {
            ...newFormValues,
            [currentField]: {
              ...newFormValues[currentField],
              error: true,
            },
          };
        }
      }
      setFormValues(newFormValues);
      if (triggerSubmit) {
        callLoginApi(newFormValues);
      }
    } else {
      setFormValues((prevState) => ({
        ...prevState,
        userEmail: {
          value: formValues.userEmail.value,
          error: true,
          errorMessage: 'Check the email address is valid',
        },
      }));
    }
  };

  const handleClose = () => {
    onClose(false);
  };

  return (
    <Dialog
      open={open}
      onClose={() => handleClose()}
      PaperProps={{
        sx: {
          borderRadius: '5px',
          minWidth: matchessm
            ? '80%'
            : matchesmd
            ? 'auto'
            : !dontallowtooffer
            ? '1000px'
            : '650px',
          boxShadow: ' -4px, 4px rgba(0, 0, 0, 0.09)',
          height: !dontallowtooffer ? '700px' : 'auto',
          padding: dontallowtooffer && '20px',
        },
      }}
    >
      {dontallowtooffer ? (
        <Grid container height={'100%'}>
          <Grid item xs={12}>
            <Typography
              sx={{
                ...poppins400,
                fontSize: matchessm ? '10px' : '14px',
                color: '#666666',
              }}
            >
              {'   '}
              {address}
              &nbsp;
            </Typography>
          </Grid>
          <Grid item xs={12} display={'flex'} alignItems={'center'}>
            <Grid
              item
              xs={12}
              display={'flex'}
              alignItems={'center'}
              padding={'12px 0px 15px 0'}
            >
              <Warning />
              <Typography
                sx={{
                  ...poppins500,
                  fontSize: matchessm ? '16px' : '24px',
                  paddingLeft: '12px',
                }}
              >
                Withdraw Last Offer to Make a New Offer
              </Typography>
            </Grid>
          </Grid>
          <Grid item>
            <Typography
              sx={{
                ...poppins400,
                fontSize: matchessm ? '12px' : '16px',
                color: '#666666',
                paddingTop: '-10px',
              }}
            >
              To submit a new offer, please withdraw your previous one, as its
              status hasn’t been updated.
            </Typography>
          </Grid>

          <Grid
            item
            container
            direction="row"
            sx={{ display: 'flex', alignItems: 'center' }}
            justifyContent={matchessm ? 'center' : 'flex-end'}
            gap={matchessm ? '5px' : 2}
            marginTop={matchessm ? '15px' : 4}
          >
            <Grid
              item
              sx={{
                position: 'relative',
                display: 'flex',
                alignItems: 'center',
                order: matches400 ? 0 : 1,
              }}
            >
              <Button
                variant="outlined"
                onClick={handleClose}
                style={{
                  padding: matchessm ? '6px 23px' : '10px 39px',
                  width: '100%',
                  height: matchessm ? '35px' : '41px',
                  fontSize: matchessm ? '12px' : '14px',
                  color: '#FFFFFF',
                  fontWeight: '400',
                  fontFamily: 'Poppins',
                  background: '#4CA4D6',
                  borderRadius: '5px',
                  textTransform: 'capitalize',
                }}
              >
                Close
              </Button>
            </Grid>
          </Grid>
        </Grid>
      ) : (
        <Grid sx={{ display: 'flex', height: '100%' }}>
          <Grid
            style={{
              position: 'relative',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: matchesmd && !matchessm && 'center',
              margin: matchesmd ? '30px' : '80px',
              width: matchesmd ? '100%' : '80%',
            }}
          >
            <img
              src={Image}
              style={{
                width: '250px',
                height: '100px',
                position: 'absolute',
                top: matchesmd ? '-30px' : '-80px',
                left: matchesmd ? '-30px' : '-80px',
              }}
            />
            <img
              src={LoginBottom}
              style={{
                width: '300px',
                height: '100px',
                position: 'absolute',
                bottom: matchesmd ? '-30px' : '-80px',
                right: matchesmd ? '-30px' : '-80px',
              }}
            />
            <Box
              sx={{ paddingBottom: matchessm ? '1em' : '3.5em', zIndex: 1 }}
              textAlign={matchesmd && 'left'}
            >
              <Typography sx={matchessm ? loginFormHeadersm : loginFormHeader}>
                {showsendOTP
                  ? 'OTP Verification Password'
                  : showForgotPassword
                  ? 'Forgot Password?'
                  : shownewpassword
                  ? 'Reset Password'
                  : !matchessm
                  ? 'Log into retreX'
                  : 'Login'}
              </Typography>
              <Typography
                component="p"
                sx={!matchessm ? loginFormText : loginFormTextsm}
              >
                {showsendOTP
                  ? 'Please enter four digit OTP sent to your mobile'
                  : showForgotPassword
                  ? 'Please enter your email address. We will send you an OTP to reset your password.'
                  : shownewpassword
                  ? 'Please enter the new password'
                  : 'Enter your login details below.'}
              </Typography>
            </Box>

            {showForgotPassword ? (
              <ForgotPassword
                setShowsendOTP={setShowsendOTP}
                showsendOTP={showsendOTP}
                shownewpassword={shownewpassword}
                setShowForgotPassword={setShowForgotPassword}
                handleShowNewPassword={handleShowNewPassword}
                setotpResponseObj={setotpResponseObj}
              />
            ) : showsendOTP ? (
              <SendOTP
                setShowsendOTP={setShowsendOTP}
                handleShowNewPassword={handleShowNewPassword}
              />
            ) : shownewpassword ? (
              <ShowNewPassword
                otpResponseObj={otpResponseObj}
                setShowForgotPassword={setShowForgotPassword}
                setShowsendOTP={setShowsendOTP}
                setShowNewPassword={setShowNewPassword}
              />
            ) : (
              <Box autoComplete="off" component={'form'} method="post">
                <Typography component="div" sx={loginMailDiv}>
                  <Typography
                    component="label"
                    sx={!matchesmd ? loginLabelEmail : emailText}
                  >
                    Email Address
                  </Typography>
                  <Typography
                    component="div"
                    sx={{ paddingTop: '10px', paddingRight: '5%' }}
                  >
                    <TextField
                      error={formValues.userEmail.error}
                      variant="outlined"
                      size={matchessm ? 'small' : ''}
                      tabIndex={1}
                      sx={{
                        '.MuiFormHelperText-contained': {
                          margin: '0',
                        },
                        '& .MuiOutlinedInput-root': {
                          '& fieldset': {
                            borderColor: 'rgba(0, 85, 255, 0.64)',
                          },
                        },
                        width: !matchessm ? '424px' : '100%',
                        background: 'transparent',
                        borderRadius: '5px',
                        color: '#000000',
                      }}
                      placeholder="name@Example:.com.au"
                      id="userEmail"
                      type="email"
                      name="userEmail"
                      value={formValues.userEmail.value}
                      inputProps={{
                        style: {
                          fontFamily: 'poppins',
                          textTransform: 'lowercase',
                        },
                      }}
                      onChange={handleChange}
                      helperText={
                        formValues.userEmail.error && (
                          <div
                            style={{
                              fontWeight: 600,
                              fontSize: matchessm ? '10px' : '13px',
                            }}
                          >
                            {formValues.userEmail.errorMessage}
                          </div>
                        )
                      }
                      InputProps={{
                        style: {
                          fontSize: matchessm
                            ? '12px'
                            : matchesmd
                            ? '14px'
                            : '',
                        },
                        startAdornment: (
                          <InputAdornment position="start">
                            <img
                              alt="img"
                              src={mailicon}
                              style={{
                                background: 'transparent',
                                paddingRight: '10px',
                                borderRight: '1px solid black',
                                width: matchesmd ? '25px' : '40px',
                                height: matchesmd ? '20px' : '',
                              }}
                            />
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Typography>
                </Typography>
                <Typography component="div">
                  <Typography
                    component="div"
                    sx={[
                      loginPassCont,
                      { width: !matches500 ? '424px' : '100%' },
                    ]}
                  >
                    <Typography
                      component="label"
                      sx={!matchesmd ? loginLabelEmail : emailText}
                    >
                      Password
                    </Typography>
                    <Typography
                      component="a"
                      href="#"
                      tabIndex={5}
                      sx={!matchesmd ? forgotPasswordLink : emailForgot}
                      style={{
                        textDecoration: 'none',
                        cursor: 'pointer',
                      }}
                      onClick={handleForgotPasswordClick}
                    >
                      Forgot your password?
                    </Typography>
                  </Typography>
                  <Typography
                    component="div"
                    sx={{ paddingTop: '10px', paddingRight: '5%' }}
                    autoComplete
                    width="100%"
                  >
                    <TextField
                      error={formValues.userPassword.error}
                      variant="standard"
                      tabIndex={2}
                      size={matchessm ? 'small' : ''}
                      inputProps={{
                        style: {
                          paddingTop: matchessm ? '7px' : '7px',
                          fontFamily: 'poppins',
                        },
                      }}
                      sx={{
                        fontSize: matchessm
                          ? '12px'
                          : matchesmd
                          ? '14px'
                          : '16px',
                        fontFamily: 'poppins !important',
                        fontStyle: 'normal !important',
                        borderRadius: '5px',
                        background: 'transparent',
                        border: '1px solid rgba(0, 85, 255, 0.64)',
                        height: matchessm ? '35px' : '60px',
                        padding: matchessm ? '2px 10px 0px 10px' : '16px 10px',
                        width: !matchessm ? '424px' : '100%',
                        '& .MuiInputBase-input::placeholder': {
                          fontSize: matchessm ? '16px' : '20px',
                          fontWeight: 'bold',
                        },
                      }}
                      name="userPassword"
                      id="userPassword"
                      placeholder="&#42; &#42; &#42; &#42; &#42; &#42; &#42;"
                      type={showPassword ? 'text' : 'password'}
                      value={formValues.userPassword.value}
                      onKeyDown={(e) => {
                        if (e.key === ' ') {
                          e.preventDefault();
                        }
                      }}
                      onChange={handleChange}
                      onKeyUp={(e) => {
                        setFormValues({
                          ...formValues,
                          userPassword: {
                            ...formValues.userPassword,
                          },
                        });
                      }}
                      helperText={
                        formValues.userPassword.error && (
                          <div
                            style={{
                              paddingTop: '8px',
                              fontWeight: 600,
                              fontSize: matchessm ? '10px' : '13px',
                              marginLeft: '-11px',
                            }}
                          >
                            {formValues.userPassword.errorMessage}
                          </div>
                        )
                      }
                      InputProps={{
                        disableUnderline: true,
                        style: {
                          fontSize: matchessm
                            ? '12px'
                            : matchesmd
                            ? '14px'
                            : '',
                        },
                        startAdornment: (
                          <InputAdornment position="start">
                            <img
                              alt="key"
                              src={keyicon}
                              style={{
                                paddingRight: '6px',
                                borderRight: '1px solid black',
                                width: matchesmd ? '25px' : '40px',
                                height: matchesmd ? '20px' : '',
                              }}
                            />
                          </InputAdornment>
                        ),
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              onClick={handleTogglePassword}
                              edge="end"
                              size="small"
                            >
                              {showPassword ? (
                                <VisibilityOff />
                              ) : (
                                <Visibility />
                              )}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Typography>
                </Typography>
                {!matchesmd && (
                  <FormControlLabel
                    sx={{
                      ...remberTextField,
                      ...paddTop10,
                      marginLeft: '-25px',
                    }}
                    tabIndex={3}
                    control={
                      <Checkbox
                        onClick={() => setRemember(true)}
                        value="remember"
                        disableFocusRipple
                        disableTouchRipple
                        disableRipple
                      />
                    }
                    label={
                      <Typography
                        sx={{
                          fontFamily: 'Poppins',
                          fontSize: '14px',
                          color: '#737497',
                          marginTop: '3px',
                        }}
                      >
                        {' '}
                        Remember me
                      </Typography>
                    }
                  />
                )}
                <Typography
                  component="div"
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginTop: '50px',
                    flexDirection: matchesmd && 'column',
                  }}
                >
                  {!logLoader ? (
                    <Button
                      onClick={handleSubmit}
                      tabIndex={4}
                      disabled={logLoader}
                      style={{
                        fontFamily: 'poppins',
                        background: '#8651D9',
                        color: 'white',
                        fontSize: !matchesmd ? '16px' : '12px',
                        fontWeight: 400,
                        padding: !matchesmd ? '10px 60px' : '10px 30px',
                        borderRadius: '50px',
                        width: matchesmd && '100%',
                      }}
                      size="large"
                      type="submit"
                    >
                      Login
                    </Button>
                  ) : (
                    <Grid sx={{ display: 'flex', justifyContent: 'center' }}>
                      <img
                        alt="Logo"
                        src={Loading}
                        className="loaderImage"
                        style={{ height: '45px', width: '45px' }}
                      />
                    </Grid>
                  )}
                  {matchesmd && (
                    <>
                      <Typography
                        sx={{
                          fontFamily: 'poppins',
                          fontSize: !matchesmd ? '20px' : '14px',
                          fontWeight: 500,
                          margin: !matchesmd ? '25px 0' : '15px 0',
                        }}
                      >
                        OR
                      </Typography>
                      <Button
                        onClick={() => {
                          history.push('/signup');
                        }}
                        style={{
                          display: 'block',
                          fontFamily: 'poppins',
                          color: '#8651D9',
                          fontSize: !matchesmd ? '16px' : '12px',
                          fontWeight: 400,
                          padding: !matchesmd ? '10px 60px' : '8.8px 30px',
                          borderRadius: '50px',
                          marginTop: !matchesmd && '50px',
                          border: '1px solid #8651D9',
                          width: '100%',
                        }}
                      >
                        Register
                      </Button>
                    </>
                  )}
                </Typography>
              </Box>
            )}
            {matchesmd &&
              (showForgotPassword || showsendOTP || shownewpassword) && (
                <Typography
                  component={'Box'}
                  sx={{
                    fontSize: matchessm ? '12px' : '16px',
                    color: '#8651D9',
                    fontFamily: 'poppins',
                    fontWeight: 300,
                    marginTop: '20px',
                    textAlign: 'center',
                  }}
                >
                  Already Have An Account?{' '}
                  <Typography
                    component="span"
                    sx={{
                      fontSize: matchessm ? '13px' : '16px',
                      color: '#8651D9',
                      fontFamily: 'poppins',
                      fontWeight: 500,
                      textDecoration: 'underline',
                      cursor: 'pointer',
                    }}
                    onClick={() => {
                      setShowForgotPassword(false);
                      setShowsendOTP(false);
                      setShowNewPassword(false);
                    }}
                  >
                    Login
                  </Typography>
                </Typography>
              )}
          </Grid>
          {!matchesmd && (
            <Grid
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: '30px',
                background: '#345B83',
                width: '100%',
                height: '100%',
                padding: '15px 30px',
              }}
            >
              <Grid>
                <RetrexLogo />
              </Grid>
              {showForgotPassword || showsendOTP || shownewpassword ? (
                <>
                  <Grid>
                    <Typography
                      sx={{
                        fontFamily: 'poppins',
                        fontSize: '36px',
                        fontWeight: 700,
                        color: 'white',
                      }}
                    >
                      Welcome Back!
                    </Typography>
                  </Grid>
                  <Grid sx={{ textAlign: 'center' }}>
                    <Typography
                      sx={{
                        fontFamily: 'poppins',
                        fontSize: '16px',
                        fontWeight: 300,
                        color: 'white',
                        textAlign: 'center',
                      }}
                    >
                      If you remember your password, you can go back to the
                      login screen.
                    </Typography>
                  </Grid>
                  <Grid>
                    <Button
                      onClick={() => {
                        setShowForgotPassword(false);
                        setShowsendOTP(false);
                        setShowNewPassword(false);
                      }}
                      style={{
                        fontFamily: 'poppins',
                        color: 'white',
                        fontSize: '16px',
                        fontWeight: 400,
                        padding: '10px 60px',
                        borderRadius: '50px',
                        marginTop: '50px',
                        border: '1px solid white',
                      }}
                    >
                      Login
                    </Button>
                  </Grid>
                </>
              ) : (
                <>
                  <Grid>
                    <Typography
                      sx={{
                        fontFamily: 'poppins',
                        fontSize: '36px',
                        fontWeight: 700,
                        color: 'white',
                      }}
                    >
                      Hello, Friend!
                    </Typography>
                  </Grid>
                  <Grid sx={{ textAlign: 'center' }}>
                    <Typography
                      sx={{
                        fontFamily: 'poppins',
                        fontSize: '16px',
                        fontWeight: 300,
                        color: 'white',
                        textAlign: 'center',
                      }}
                    >
                      First time? retreX is your all-in-one real estate solution
                      for seamless home buying – Find, Offer, and Purchase, all
                      in a single place.
                    </Typography>
                  </Grid>
                  <Grid>
                    <Button
                      onClick={() => {
                        history.push('/signup');
                      }}
                      style={{
                        fontFamily: 'poppins',
                        color: 'white',
                        fontSize: !matchesmd ? '16px' : '12px',
                        fontWeight: 400,
                        padding: '10px 60px',
                        borderRadius: '50px',
                        marginTop: !matchesmd && '50px',
                        border: '1px solid white',
                      }}
                    >
                      Register
                    </Button>
                  </Grid>
                </>
              )}
            </Grid>
          )}
        </Grid>
      )}
    </Dialog>
  );
}
